import { useQuery } from '@tanstack/react-query';
import { getAllFamilies } from 'services/api/requests/requests';

export const useFamilyListAll = () => {
	return useQuery(['family-list-all'], getAllFamilies, {
		refetchOnWindowFocus: false,
	});
};
